import { Text, UseModalState } from "@clipboard-health/ui-react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
} from "@mui/material";
import { format } from "date-fns";
import { ShiftInviteInfo } from "../ShiftInviteReview";
import { useShiftInviteContext } from "../Context/shiftInviteContext";
import { formatCbhApiError, isCbhApiSuperagentError } from "@src/appV2/lib/utils/errorUtils";

type MultiShiftInviteErrorDialogProps = {
  modalState: UseModalState;
  failedInvites: ShiftInviteInfo[];
  onClose: () => void;
};

export function MultiShiftInviteErrorDialog(props: MultiShiftInviteErrorDialogProps) {
  const { modalState, failedInvites, onClose } = props;
  const { addUserJourneyEvent, logUserJourney } = useShiftInviteContext();

  return (
    <Dialog
      open={modalState.modalIsOpen}
      onClose={() => {
        addUserJourneyEvent("click", "Backdrop (Multi Shift Invite Error Dialog)");
        modalState.closeModal();
      }}
      aria-labelledby="shift--multi-invite-error-dialog-title"
    >
      <DialogTitle>Some invitations could not be sent.</DialogTitle>
      <DialogContent>
        These invites could not be sent, please try again.
        <List>
          {failedInvites.map((invite) => {
            let errorMessage: string | undefined;
            if (invite.error && isCbhApiSuperagentError(invite.error)) {
              const firstError = invite.error.response.body.errors[0];
              errorMessage = formatCbhApiError(firstError);
            }

            return (
              <ListItem
                key={`${invite.start.getTime()}-${invite.end.getTime()}`}
                sx={{ display: "block", paddingY: 1 }}
              >
                <Text variant="body1">
                  {format(invite.start, "MM/dd/yy h:mm a")} to {format(invite.end, "h:mm a")}
                </Text>
                {errorMessage && (
                  <Text variant="body2" color="error" sx={{ marginTop: 0.5 }}>
                    {errorMessage}
                  </Text>
                )}
              </ListItem>
            );
          })}
        </List>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={() => {
            logUserJourney("exit", "Close Button (Multi Shift Invite Error Dialog)");
            onClose();
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
